
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { MusicManager } from './audio/GameAudioManager';

interface MainMenuProps {
  onStart: () => void;
}

export const MainMenu: React.FC<MainMenuProps> = ({ onStart }) => {


  // Memoize the start function to prevent re-creation and ensure effect cleanup is stable
  const startGame = useCallback(() => {
    MusicManager.initialize();
    onStart();
  }, [onStart]);



  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center overflow-y-auto overflow-x-hidden p-4">
      <div className="fixed inset-0 bg-grid-slate-800/20 [mask-image:linear-gradient(to_bottom,white_20%,transparent_100%)] pointer-events-none"></div>

      <div className="relative z-10 p-6 md:p-16 w-full max-w-4xl mx-auto text-center glass-panel flex flex-col items-center justify-center shadow-2xl">
        <h1 className="text-5xl md:text-8xl font-heading mb-6 md:mb-8 text-cyan-400 tracking-wider leading-tight" style={{ textShadow: '0 0 15px rgba(34, 211, 238, 0.7)' }}>
          #CAWCAW
        </h1>

        <div className="text-sm md:text-xl text-slate-300 mb-8 md:mb-12 border-y-2 border-slate-700 py-3 md:py-4 px-4 md:px-6 inline-block tracking-wider uppercase font-bold bg-black/20">
          Their stage is a battlefield. Their music is magic.
        </div>

        <p className="text-slate-400 text-sm md:text-2xl mb-8 md:mb-16 leading-relaxed max-w-2xl md:max-w-4xl mx-auto px-2">
          As the producer for HUNTR/X, you must lead them to stardom
          <span className="hidden md:inline"><br /></span>
          <span className="inline md:hidden"> </span>
          while they fight back demonic forces that feed on the souls of their fans.
        </p>

        <button
          onClick={startGame}
          className="px-10 py-4 md:px-12 md:py-6 bg-cyan-600/50 border-2 border-cyan-400 hover:bg-cyan-500 text-cyan-100 text-xl md:text-2xl font-heading transition-all duration-300 shadow-[0_0_15px_rgba(34, 211, 238, 0.5)] hover:shadow-[0_0_30px_rgba(34, 211, 238, 0.8)] rounded-lg active:scale-95"
        >
          [ START ]
        </button>

      </div>
    </div>
  );
};
